module.exports = __webpack_public_path__ + "static/media/lo-01.ada75b37.png";